import { Expose, Transform } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { toCents } from "@/utils/numberUtils";

export class CreateValuationDto {
  @Expose()
  dossierId: string;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  startDate: Date;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  endDate: Date;

  @Transform(({ value }) => toCents(value))
  @Expose()
  executedAmount: number;

  @Expose()
  projectIds: string[];

  @Expose()
  responsibleUserId?: string;

  @Expose()
  notes?: string | null;
}
